import { createPinia as createPiniaOrigin } from 'pinia';
import { PiniaLogger } from 'pinia-logger';

import { TranslatableErrorHandlerPiniaPlugin } from './plugins';

export { default as useAuth } from './auth';
export { default as useUsageCostStore } from './usageCost.ts';
export { default as useAwsResourcesStore } from './awsResources.ts';
export { default as useContractsStore } from './contracts.ts';
export { default as useCustomersStore } from './customers.ts';
export { default as useEmployeesStore } from './employees.ts';
export { default as useCustomSkusStore } from './customSkus.ts';
export { default as useSessionsTrafficStore } from './sessionsTraffic.ts';
export { default as useUsageTrafficStore } from './usageTraffic.ts';
export { default as useUsageUnitsStore } from './usageUnits.ts';
export { default as useSkuMappingStore } from './skuMapping.ts';
export { default as usePatternsStore } from './patterns.ts';
export { default as usePaymentProvidersStore } from './paymentProviders.ts';
export { default as usePaymentsStore } from './payments.ts';
export { default as usePermissionsStore } from './permissions.ts';
export { default as useTiersStore } from './tiers.ts';
export { default as useVendorsStore } from './vendors.ts';
export { default as useCategoriesStore } from './categories.ts';
export { default as useSkusStore } from './skus.ts';
export { default as useProgressiveTiersStore } from './progressiveTiers.ts';
export { default as useEnvironmentsStore } from './environments.ts';
export { default as usePrepaymentsStore } from './prepayments.ts';
export { default as useAccountsStore } from './accounts.ts';
export { default as useReportingDatabasesStore } from './reportingDatabases.ts';
export { default as useReportingDatabasesCronSettingsStore } from './reportingDatabasesCronSettings.ts';
export { default as useThresholdManagementStore } from './thresholdManagement.ts';
export { default as useSageJournalStatusStore } from './sageJournalStatus.ts';
export { default as useReconciliationsRunsStore } from './reconciliation.ts';
export { default as useAuditStore } from './audit.ts';
export { default as useRecompileUsageStore } from './usageProcessingJobs.ts';
export { default as useContactsStore } from './contacts.ts';
export { default as useContactSkillsStore } from './contactSkills.ts';
export { default as useContactTypesStore } from './contactTypes.ts';
export { default as useUsersStore } from './users.ts';
export { default as useFlowsStore } from './flows.ts';
export { default as usePollingStore } from './polling.ts';
export { default as useErroredSkusStore } from './erroredSkus';
export { default as useInvoicingStore } from './invoicing.ts';
export { default as useLoginAuditStore } from './loginAudit.ts';

function createPinia() {
  return createPiniaOrigin()
    .use(PiniaLogger({
      expanded: false,
      disabled: process.env.NODE_ENV === 'production',
    }))
    .use(TranslatableErrorHandlerPiniaPlugin);
}

export default createPinia;
